<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Rename</h4>
  <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
</div>
<div class="modal-body text-grey">
  <form name="renameForm" [formGroup]="renameForm" (ngSubmit)="onSubmit(renameForm)" autocomplete="off" spellcheck="false">
    <mat-form-field style="width: 100%;">
      <mat-label>Directory/File Name</mat-label>
      <input placeholder="Directory/File Name."
             formControlName="fileName"
             matInput
             style="overflow: none!important;" />
      <mat-error *ngIf="renameForm.get('fileName').touched &&
      renameForm.get('fileName').errors?.required">Required</mat-error>
      <mat-error *ngIf="renameForm.get('fileName').touched &&
      renameForm.get('fileName').errors?.pattern">
       Only Alphabets, Number, '_', '-' allowed.
        <!---<span title="Only Alphabets, Number, '@', '_', '-' allowed."
  class="bi bi-info"></span>-->
      </mat-error>
    </mat-form-field>
  </form>
  <p style="color: red;">Note : Rename operation completion time may vary as per size of file/directory.</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" mat-dialog-close>Cancel</button>
  <button type="button" class="btn btn-primary" (click)="onSubmit(renameForm)">
    Rename
  </button>
</div>
